import { render, staticRenderFns } from "./UnitTable.vue?vue&type=template&id=beffae8c&scoped=true"
import script from "./UnitTable.vue?vue&type=script&lang=js"
export * from "./UnitTable.vue?vue&type=script&lang=js"
import style0 from "./UnitTable.vue?vue&type=style&index=0&id=beffae8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beffae8c",
  null
  
)

export default component.exports